export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

/** Clerk-hosted sign-in at this path (see `App.tsx`). */
export const getLoginUrl = () => "/sign-in";
